// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mp-c";
export var backButton = "_mp-4";
export var backIcon = "_mp-5";
export var chevronShortcut = "_mp-6";
export var container = "_mp-1";
export var editor = "_mp-8";
export var editorWrapper = "_mp-7";
export var prefix = "_mp-2";
export var searchIcon = "_mp-3";
export var suffix = "_mp-9";
export var suffixContent = "_mp-a";
export var suffixText = "_mp-b";
export var wrapper = "_mp-0";